import $styles from "./themes";

import Routable from "@mixins/routable";
import { factory as GroupableFactory } from "@mixins/groupable";
import { factory as ToggleableFactory } from "@mixins/toggleable";

import mixins from "@utils/mixins";

import ProgressCircular from "@/components/ui/progress-bar/ProgressCircular";

const baseMixins = mixins(
  Routable,
  GroupableFactory("btnToggle"),
  ToggleableFactory("inputValue")
);

export default baseMixins.extend({
  name: "AppBtn",
  props: {
    tag: {
      type: String,
      default: "button"
    },
    type: {
      type: String,
      default: "button"
    },
    activeClass: {
      type: String,
      default() {
        if (!this.btnToggle) return "";

        return this.btnToggle.activeClass;
      }
    },
    color: {
      type: String,
      default: "primary"
    },
    retainFocusOnClick: Boolean,
    block: Boolean,
    rounded: Boolean,
    loading: Boolean,
    value: null
  },

  data() {
    return {
      proxyClass: ($styles[this.color] && $styles[this.color].active) || ""
    };
  },

  computed: {
    _styles() {
      return $styles[this.color] || {};
    },

    classes() {
      return {
        ...Routable.computed.classes.call(this),
        [this._styles.button]: !this.disabled,
        [this._styles.disabled]: this.disabled,
        [this._styles.loading]: this.loading,
        [this._styles.block]: this.block,
        [this._styles.rounded]: this.rounded
      };
    },

    childrens: () => []
  },

  methods: {
    click(e) {
      !this.retainFocusOnClick && e.detail && this.$el.blur();
      this.$emit("click", e);
      this.btnToggle && this.toggle();
    },

    genContent() {
      return this.$createElement(
        "div",
        {
          class: {
            [this._styles.content]: true
          }
        },
        this.$slots.default
      );
    },

    genLoader() {
      return this.$createElement(
        "span",
        { class: this._styles.loader },
        this.$slots.loader || [
          this.$createElement(ProgressCircular, {
            props: {
              indeterminate: true,
              size: 23,
              width: 3
            }
          })
        ]
      );
    }
  },

  render(h) {
    const { tag, data } = this.generateRouteLink();
    const children = this.childrens.concat([
      this.genContent(),
      this.loading && this.genLoader()
    ]);

    if (tag === "button") {
      data.attrs.type = this.type;
      data.attrs.disabled = this.disabled;
    }

    return h(tag, data, children);
  }
});
